import React from 'react';
import PropTypes from 'prop-types';

import CommonJobInfo from '../jobDetails/JobInfo';

import { HIRE_MODES } from '@/constants/common';
import jobCategory from '@/constants/jobCategory';
import {
  formatLocationToShortStr,
  getSalaryRangeDisplay,
  parseMultiSelectValueDisplayLabel,
} from '@/utils/common';
import { getI18n } from '@/utils/i18n';

const i18n = getI18n();

function JobInfo({ currentJob, headhunterJobFields }) {
  const {
    departmentName,
    // eslint-disable-next-line @moka-fe/no-2-4
    category2Id,
    locations,
    minExperience,
    maxExperience,
    commitment,
    minSalary,
    maxSalary,
    payPeriod,
    salaryUnit,
    paymentMethod,
    number,
    hireMode,
    zhineng,
    customFields = {},
    jobRanks = [],
  } = currentJob;
  let categoryName;
  if (category2Id) {
    const numberList = String(category2Id).split('.');
    if (numberList.length === 3) {
      categoryName =
        jobCategory[numberList[0] - 1].children[numberList[1] - 1].children[numberList[2] - 1].name;
    } else if (numberList.length === 2) {
      categoryName = jobCategory[numberList[0] - 1].children[numberList[1] - 1].name;
    }
  }

  let experience = i18n.t`不限`;
  if (minExperience !== null) {
    if (maxExperience === null) {
      experience = i18n.t`${minExperience}年以上`;
    } else if (maxExperience === 0) {
      experience = i18n.t`应届毕业生`;
    } else if (minExperience && maxExperience) {
      experience = i18n.t`${minExperience}年至${maxExperience}年`;
    }
  }

  // order matters
  const infoItems = [];
  if (headhunterJobFields.location && locations) {
    infoItems.push({
      name: i18n.t`工作地点`,
      value: locations
        .map((location) => {
          return formatLocationToShortStr(location, '-');
        })
        .join(', '),
    });
  }
  if (headhunterJobFields.department) {
    infoItems.push({ name: i18n.t`所属部门`, value: departmentName });
  }
  if (headhunterJobFields.category) {
    infoItems.push({ name: i18n.t`职位类别`, value: categoryName });
  }
  if (headhunterJobFields.experience) {
    infoItems.push({ name: i18n.t`工作经验`, value: experience });
  }
  if (headhunterJobFields.commitment) {
    infoItems.push({ name: i18n.t`职位性质`, value: i18n._(commitment) });
  }

  if (headhunterJobFields.salary) {
    let salaryValue;
    if (!maxSalary && !minSalary) {
      salaryValue = '-';
    } else {
      salaryValue = getSalaryRangeDisplay({
        minSalary,
        maxSalary,
        payPeriod,
        salaryUnit,
        paymentMethod,
      });
    }
    infoItems.push({ name: i18n.t`薪资范围`, value: salaryValue });
  }
  if (headhunterJobFields.number) {
    infoItems.push({ name: i18n.t`招聘人数`, value: number });
  }
  if (headhunterJobFields.type) {
    infoItems.push({
      name: i18n.t`招聘类型`,
      value: hireMode === HIRE_MODES.CAMPUS ? i18n.t`校园招聘` : i18n.t`社会招聘`,
    });
  }
  if (headhunterJobFields.zhineng) {
    infoItems.push({ name: i18n.t`职能类型`, value: zhineng });
  }
  if (headhunterJobFields.jobRanks) {
    infoItems.push({ name: i18n.t`职位级别`, value: jobRanks.join('、') });
  }

  // for customer fields, parse it from true/false to 是/否
  const parseValue = (type, value) => {
    // 多选题情况
    if (type === 'multi_select_info') {
      return parseMultiSelectValueDisplayLabel(value);
    }
    return typeof value === 'string' ? value : value ? i18n.t`是` : i18n.t`否`;
  };
  infoItems.push(
    ...Object.values(customFields).map((item) => {
      item.value = parseValue(item.type, item.value);
      return item;
    })
  );

  return <CommonJobInfo infoItems={infoItems} itemPerRow={3} />;
}

JobInfo.propTypes = {
  currentJob: PropTypes.object,
  headhunterJobFields: PropTypes.object,
};

export default JobInfo;
